import { render, staticRenderFns } from "./NoCamps.vue?vue&type=template&id=afccf1c0&scoped=true"
import script from "./NoCamps.vue?vue&type=script&lang=ts"
export * from "./NoCamps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afccf1c0",
  null
  
)

export default component.exports